var _jsxFileName = "/repo/packages/webassets/src/components/Experiments/index.tsx",
  _this = this;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useContext, createContext } from 'react';
import PropTypes from 'prop-types';
import { Query } from '@apollo/client/react/components';
import { getClientEnvironmentDetails } from '@sm/utils';
import experimentsQuery from './Experiments.graphql';
export var expContext = /*#__PURE__*/createContext({
  experiments: [],
  loading: true
});
var ExperimentProvider = function ExperimentProvider(props) {
  var _getClientEnvironment = getClientEnvironmentDetails(),
    isBrowser = _getClientEnvironment.isBrowser;
  var pageReferer = isBrowser ? document.referrer : '/';
  var pageUrl = isBrowser ? window.location.href : '/';
  return /*#__PURE__*/React.createElement(Query, {
    query: experimentsQuery,
    fetchPolicy: "no-cache",
    variables: {
      pageReferer: pageReferer,
      pageUrl: pageUrl
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 62,
      columnNumber: 5
    }
  }, function (_ref) {
    var data = _ref.data,
      loading = _ref.loading;
    var expList = data && data.experiments || [];
    return /*#__PURE__*/React.createElement(expContext.Provider, Object.assign({
      value: {
        experiments: expList,
        loading: loading
      }
    }, props, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 70,
        columnNumber: 11
      }
    }));
  });
};
function useExperiment(_ref2) {
  var name = _ref2.name,
    treatmentNames = _ref2.treatmentNames;
  var context = useContext(expContext);
  var experiments = context.experiments,
    loading = context.loading;
  var baseObj = {
    treatments: {},
    loading: loading
  };

  // if loading, we want to fire the loading component provide by the user
  if (loading) return baseObj;

  // If the service fails, or the experiments are undefined, we will want to show the control.
  if (!experiments) return baseObj;

  // match the name to the list of experiments that have come back
  var expObj = experiments.find(function (exp) {
    return name === exp.name;
  });
  if (!expObj) return baseObj;
  var notAssigned = {};
  treatmentNames.forEach(function (treatment) {
    if (treatment !== expObj.treatment.name) {
      notAssigned[treatment] = {};
    }
  });
  var reduced = Object.keys(expObj).reduce(function (acc) {
    // eslint-disable-next-line no-param-reassign
    acc = {
      treatments: _defineProperty({}, expObj.treatment.name, {
        treatmentName: expObj.treatment.name,
        treatmentId: expObj.treatment.id,
        experimentId: expObj.id,
        experimentName: expObj.name,
        assignmentType: expObj.assignmentType
      }),
      name: expObj.name,
      loading: loading
    };
    return acc;
  }, {
    loading: loading,
    treatments: {}
  });
  Object.assign(reduced.treatments, notAssigned);
  return reduced;
}
ExperimentProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export { ExperimentProvider, useExperiment };
//# sourceMappingURL=index.js.map